import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Autocomplete,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  IconButton,
  MenuItem,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMessage } from "../../context/message-context";
import apiRequest from "../../functions/api";
import { DateTextField, DateTimeTextField, istInteger, prec } from "../lib";
import BetragInput from "../shared/components/BetragInput";
import ZeitraumInput from "../shared/components/ZeitraumInput";
import { setColor2 } from "../../functions/default";
function FormularFeld(props) {
  // eslint-disable-next-line
  const { element, ind, gruppe, Summe, uebergaben, lock, ChangeFiles, files, DateiLaden, client, accessToken, program, ZSpeichern, felderError } = props;
  const [item, setItem] = useState(element);
  const theme = useTheme();
  const { showErrorMessage } = useMessage();
  const { t } = useTranslation();
  const [filekey, setFilekey] = useState(1);
  useEffect(() => {
    // eslint-disable-next-line
  }, [props]);

  useEffect(() => {
    setItem(element);
    // eslint-disable-next-line
  }, [element]);

  const PostWertChange = (feld, index, value, typ, von, bis) => {
    if (Number(value) == 0) return;
    if (Number(von) == 0 && Number(bis) == 0) return;
    if (Number(von) == NaN || Number(bis) == NaN) return;

    if (typ === "02" || typ === "10" || typ === "11") {
      var tmp = Number(value);
      if (tmp > Number(bis)) {
        tmp = Number(bis);
        WertChange(feld, index, tmp);
      }
      if (tmp < Number(von)) {
        tmp = Number(von);
        WertChange(feld, index, tmp);
      }
    }
  };

  const ValidateWertChange = (feld, index, value, typ, limit) => {
    if (typ === "10") {
      if (istInteger(value) === false) return;
    }
    if (typ === "11") {
      if (prec(Number(value)) > 2) return;
    }
    if (typ === "01") {
      if (limit > 0 && value.length > limit) return;
    }
    WertChange(feld, index, value);
  };

  function CBGroup(feld, index, value, length, multi) {
    if (multi === "02") {
      if (value === 0) {
        WertChange(feld, index + grp_index, value);
      } else {
        var tmpantwort = { [index]: value };
        WertChange(feld, -1, tmpantwort);
      }
    } else {
      WertChange(feld, index, value);
    }
  }
  function CBGroupGruppe(feld, index, value, length, multi, grp_index = 0) {
    if (multi === "02") {
      if (value === 0) {
        WertChange(feld, index + "_" + grp_index, value);
      } else {
        var tmpantwort = { [index + "_" + grp_index]: value };
        WertChange(feld, -1, tmpantwort);
      }
    } else {
      WertChange(feld, index + "_" + grp_index, value);
    }
  }

  function DateCheck(feld, index, value) {
    WertChange(feld, index, value);
  }

  const WertChange = (feld, index, value) => {
    let newValue = value;
    if (newValue === true) newValue = "1";
    if (newValue === false) newValue = "";

    var indexstring = index.toString();

    if (index < 0) {
      setItem((prevState) => {
        let newItem = { ...prevState };
        newItem.antwort = newValue;

        // sync with [arent array]
        props.onChange(feld, newItem);

        return newItem;
      });
    } else {
      /*setItem(prevState => {
        let newItem = { ...prevState,};

        if (!newItem.antwort) newItem.antwort={}
        newItem.antwort[indexstring]=newValue;
  
        // sync with [arent array
        props.onChange(feld, newValue, indexstring, gruppe);
  
        return newItem;
      });*/
      let newItem = { ...item };

      if (!newItem.antwort) newItem.antwort = {};
      newItem.antwort[indexstring] = newValue;

      setItem(newItem);

      props.onChange(feld, newValue, indexstring, gruppe);
    }
  };

  function Rechenfeld(inhalt, art, ind) {
    return Summe(inhalt, art, gruppe, ind);
  }

  function Validate(inhalt) {
    var vinhalt = inhalt;
    if (!uebergaben) return vinhalt;
    var tmppos = inhalt.indexOf("|");
    if (tmppos >= 0) {
      var feld = inhalt.substr(tmppos, 5);
      var tmpinhalt = uebergaben["f" + feld.substr(1, 3)];

      if (Object.prototype.toString.call(tmpinhalt) === "[object Object]") {
        if (ind === -1) {
          var tmpsumme = 0;
          Object.values(tmpinhalt).forEach((fvalue) => {
            tmpsumme += Number(fvalue);
          });
          tmpinhalt = tmpsumme;
        } else {
          if (tmpinhalt[ind]) {
            tmpinhalt = tmpinhalt[ind];
          } else {
            tmpinhalt = "";
          }
        }
      }

      vinhalt = inhalt.replace(feld, tmpinhalt);
      return Validate(vinhalt);
    }
    return vinhalt;
  }

  function getFile(event, tmpkey, kz) {
    var endung = event.target.files[0].name;
    endung = endung.substr(endung.lastIndexOf("."));
    if (endung !== ".png" && endung !== ".jpg" && endung !== ".jpeg" && endung !== ".pdf" && endung !== ".PDF") {
      showErrorMessage(
        t('Das Dateiformat "') + endung + t('" wird nicht unterstützt. Die Datei muss eines der folgenden Formate haben: ') + ".pdf, " + ".png, " + ".jpeg",
      );
      setFilekey(filekey + 1);
      return;
    }
    if (Array.from(event.target.files)?.length > 1) {
      WertChange(tmpkey, kz, files.length + "ANZAHL" + Array.from(event.target.files)?.length);
      Array.from(event.target.files).forEach((file) => {
        ChangeFiles(file);
      });
    } else {
      WertChange(tmpkey, kz, files.length);
      ChangeFiles(event.target.files[0]);
    }
  }

  function readFile(event, tmpkey, kz) {
    const payload = {
      program: program,
      statement: "OCR",
      mandant: client,
    };
    const formData = new FormData();
    formData.append("payload", JSON.stringify(payload));
    formData.append("file", event.target.files[0]);

    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", formData, headers, (response) => {
      if (response.status !== 200) {
        showErrorMessage("Fehler beim auslesen der Datei. Datei wurde nicht übernommen");
        return;
      }
      let wert = response.data.WERTE;
      var endung = event.target.files[0].name;
      endung = endung.substr(endung.lastIndexOf("."));
      wert.file = event.target.files[0];
      wert.file.number = files.length;
      ChangeFiles(event.target.files[0]);
      WertChange(tmpkey, kz, wert);
    });
  }

  // function ocrCb(response) {

  // }

  function renderFeld() {
    var italic = false;
    var bold = false;
    if (item.art === "E") {
      if (item.format && (item.format === "03" || item.format === "04")) italic = true;
      if (item.format && (item.format === "02" || item.format === "04")) bold = true;
      if (item.typ === "01") {
        return (
          <Fragment>
            <Grid item xs={12} md={4}>
              <Typography
                align="left"
                style={bold && italic ? { fontStyle: "italic", fontWeight: "bold" } : bold ? { fontWeight: "bold" } : italic ? { fontStyle: "italic" } : {}}
              >
                {item.name}
              </Typography>
            </Grid>
            <Grid item xs={12} md={8} align="left">
              <TextField
                label={!item.inhalt ? (item.label === "1" ? item.name : "") : item.antwort ? "" : item.inhalt}
                size="small"
                fullWidth
                disabled={lock}
                value={item.antwort ? item.antwort : ""}
                onChange={(e) => ValidateWertChange(item.key, -1, e.target.value, item.typ, item.limit)}
                InputLabelProps={item.inhalt ? { shrink: false } : {}}
              />
            </Grid>
          </Fragment>
        );
      }
      if (item.typ === "02") {
        return (
          <Fragment>
            <Grid item xs={12} md={4}>
              <Typography
                align="left"
                style={bold && italic ? { fontStyle: "italic", fontWeight: "bold" } : bold ? { fontWeight: "bold" } : italic ? { fontStyle: "italic" } : {}}
              >
                {item.name}
              </Typography>
            </Grid>
            <Grid item xs={12} md={8} align="left">
              <TextField
                label={item.label === "1" ? item.name : ""}
                size="small"
                fullWidth
                type="number"
                disabled={lock}
                value={item.antwort ? item.antwort : ""}
                onChange={(e) => ValidateWertChange(item.key, -1, e.target.value, item.typ, item.limit)}
                onBlur={(e) => PostWertChange(item.key, -1, e.target.value, item.typ, item.von, item.bis)}
              />
            </Grid>
          </Fragment>
        );
      }
      if (item.typ === "03") {
        return (
          <Fragment>
            <Grid item xs={12} md={4}>
              <Typography
                align="left"
                style={bold && italic ? { fontStyle: "italic", fontWeight: "bold" } : bold ? { fontWeight: "bold" } : italic ? { fontStyle: "italic" } : {}}
              >
                {item.name}
              </Typography>
            </Grid>
            <Grid item xs={12} md={8} align="left">
              <DateTextField
                size="small"
                fullWidth
                disabled={lock}
                value={item.antwort ? item.antwort : ""}
                onChange={(e) => DateCheck(item.key, -1, e.target.value)}
              />
            </Grid>
          </Fragment>
        );
      }
      if (item.typ === "04") {
        return (
          <Fragment>
            <Grid item xs={12} md={4}>
              <Typography
                align="left"
                style={bold && italic ? { fontStyle: "italic", fontWeight: "bold" } : bold ? { fontWeight: "bold" } : italic ? { fontStyle: "italic" } : {}}
              >
                {item.name}
              </Typography>
            </Grid>
            <Grid item xs={12} md={8} align="left">
              <TextField
                size="small"
                fullWidth
                type="time"
                disabled={lock}
                value={item.antwort ? item.antwort : ""}
                onChange={(e) => WertChange(item.key, -1, e.target.value)}
              />
            </Grid>
          </Fragment>
        );
      }
      if (item.typ === "05") {
        return (
          <Fragment>
            <Grid item xs={12} md={4}>
              <Typography
                align="left"
                style={bold && italic ? { fontStyle: "italic", fontWeight: "bold" } : bold ? { fontWeight: "bold" } : italic ? { fontStyle: "italic" } : {}}
              >
                {item.name}
              </Typography>
            </Grid>
            <Grid item xs={12} md={8} align="left">
              <FormControlLabel
                control={
                  <Checkbox
                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                    checked={item.antwort === "1" ? true : false}
                    onChange={(e) => WertChange(item.key, -1, e.target.checked)}
                    disabled={lock}
                  />
                }
                label={item.inhalt && item.inhalt !== "" ? item.inhalt : ""}
              />
            </Grid>
          </Fragment>
        );
      }
      if (item.typ === "06") {
        return (
          <Fragment>
            <Grid item xs={12} md={4}>
              <Typography
                align="left"
                style={bold && italic ? { fontStyle: "italic", fontWeight: "bold" } : bold ? { fontWeight: "bold" } : italic ? { fontStyle: "italic" } : {}}
              >
                {item.name}
              </Typography>
            </Grid>
            <Grid item xs={12} md={8} align="left">
              <TextField
                //select
                size="small"
                fullWidth
                select
                disabled={lock}
                value={item.antwort ? item.antwort : ""}
                onChange={(e) => WertChange(item.key, -1, e.target.value)}
              >
                {item.inhalt.split("\n").map((item2, index2) => {
                  var tmpkey = "";
                  var tmpval = "";
                  var tmppos = item2.indexOf(";");
                  if (tmppos >= 0) {
                    tmpkey = item2.substr(0, tmppos);
                    tmpval = item2.substr(tmppos + 1);
                  } else {
                    tmpkey = item2;
                    tmpval = item2;
                  }
                  return (
                    <MenuItem key={index2} value={tmpkey} index={index2}>
                      {tmpval}
                    </MenuItem>
                  );
                })}
              </TextField>
            </Grid>
          </Fragment>
        );
      }
      if (item.typ === "07") {
        return (
          <Fragment>
            <Grid item xs={12} md={4}>
              <Typography
                align="left"
                style={bold && italic ? { fontStyle: "italic", fontWeight: "bold" } : bold ? { fontWeight: "bold" } : italic ? { fontStyle: "italic" } : {}}
              >
                {item.name}
              </Typography>
            </Grid>
            <Grid item xs={12} md={8} align="left">
              <TextField
                label={!item.inhalt ? (item.label === "1" ? item.name : "") : item.antwort ? "" : item.inhalt}
                size="small"
                fullWidth
                multiline
                disabled={lock}
                value={item.antwort ? item.antwort : ""}
                onChange={(e) => WertChange(item.key, -1, e.target.value)}
                InputLabelProps={item.inhalt ? { shrink: false } : {}}
              />
            </Grid>
          </Fragment>
        );
      }
      if (item.typ === "08") {
        return (
          <Fragment>
            <Grid item xs={12} md={4}>
              <Typography
                align="left"
                style={bold && italic ? { fontStyle: "italic", fontWeight: "bold" } : bold ? { fontWeight: "bold" } : italic ? { fontStyle: "italic" } : {}}
              >
                {item.name}
              </Typography>
            </Grid>
            <Grid item xs={12} md={8}>
              <Grid container justifyContent="flex-start">
                {item.inhalt.split("\n").map((item2, index2) => {
                  return (
                    <Grid item xs={12} md={4} align="left">
                      <FormControlLabel
                        control={
                          <Checkbox
                            disabled={lock}
                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                            checked={item.antwort && item.antwort[index2.toString()] === "1" ? true : false}
                            onChange={(e) => CBGroup(item.key, index2, e.target.checked ? "1" : "0", item.inhalt.split("\n").length, item.multi)}
                          />
                        }
                        label={item2}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          </Fragment>
        );
      }
      if (item.typ === "09") {
        return (
          <Fragment>
            <Grid item xs={12} md={4}>
              <Typography
                align="left"
                style={bold && italic ? { fontStyle: "italic", fontWeight: "bold" } : bold ? { fontWeight: "bold" } : italic ? { fontStyle: "italic" } : {}}
              >
                {item.name}
              </Typography>
            </Grid>
            <Grid item xs={12} md={8} align="left">
              {lock ? (
                <Button variant="outlined" onClick={() => DateiLaden(item.antwort, "DMS")} disabled={!item.antwort || item.antwort.length <= 5}>
                  {item.antwort && item.antwort.length > 10 ? "Datei anzeigen" : "Keine Datei"}
                </Button>
              ) : item.antwort && item.antwort.length > 10 ? (
                <Fragment>
                  <Button variant="outlined" onClick={() => DateiLaden(item.antwort, "DMS")}>
                    {"Datei anzeigen"}
                  </Button>
                  <IconButton onClick={() => WertChange(item.key, -1, "")}>
                    <DeleteIcon />
                  </IconButton>
                </Fragment>
              ) : (
                <TextField
                  key={filekey}
                  size="small"
                  type="file"
                  inputProps={{
                    accept: "image/png,image/jpg,image/jpeg,application/pdf",
                    multiple: item.multi ? true : false,
                  }}
                  onChange={(e) => getFile(e, item.key, -1)}
                />
              )}
            </Grid>
          </Fragment>
        );
      }
      if (item.typ === "10") {
        return (
          <Fragment>
            <Grid item xs={12} md={4}>
              <Typography
                align="left"
                style={bold && italic ? { fontStyle: "italic", fontWeight: "bold" } : bold ? { fontWeight: "bold" } : italic ? { fontStyle: "italic" } : {}}
              >
                {item.name}
              </Typography>
            </Grid>
            <Grid item xs={12} md={8} align="left">
              <TextField
                label={item.label === "1" ? item.name : ""}
                size="small"
                fullWidth
                disabled={lock}
                value={item.antwort ? item.antwort : ""}
                onChange={(e) => ValidateWertChange(item.key, -1, e.target.value, item.typ, item.limit)}
                onBlur={(e) => PostWertChange(item.key, -1, e.target.value, item.typ, item.von, item.bis)}
              />
            </Grid>
          </Fragment>
        );
      }
      if (item.typ === "11") {
        return (
          <Fragment>
            <Grid item xs={12} md={4}>
              <Typography
                align="left"
                style={bold && italic ? { fontStyle: "italic", fontWeight: "bold" } : bold ? { fontWeight: "bold" } : italic ? { fontStyle: "italic" } : {}}
              >
                {item.name}
              </Typography>
            </Grid>
            <Grid item xs={12} md={8} align="left">
              <BetragInput
                size="small"
                disabled={lock}
                fullWidth
                von={item.von}
                bis={item.bis}
                currency={item.extra}
                label={item.label === "1" ? item.name : ""}
                value={item.antwort ? Number(item.antwort) : 0}
                negativ={item.negativ === "1" ? true : false}
                onChange={(e) => WertChange(item.key, -1, e)}

                //onBlur={(e)=>WertChange(item.key,-1,e)}
              />
            </Grid>
          </Fragment>
        );

        /*return(
          <Fragment>
          <Grid item xs={12} md={4}>
            <Typography align="left" style={(bold&&italic)?{fontStyle:"italic",fontWeight:"bold"}:(bold)?{fontWeight:"bold"}:(italic)?{fontStyle:"italic"}:{}}>{item.name}</Typography>
          </Grid>
          <Grid item xs={12} md={8} align="left">
            <TextField
              size="small"
              disabled={lock===true}
              type="number"
              fullWidth
              value={item.antwort?item.antwort:""}
              onChange={(e)=>ValidateWertChange(item.key,-1,e.target.value,item.typ)}
              InputProps={{
                startAdornment:<InputAdornment position="start">{"€"}</InputAdornment>,
              }}
            />
          </Grid>
          </Fragment>
        )
        */
      }
      if (item.typ === "12") {
        return (
          <Fragment>
            <Grid item xs={12} md={4}>
              <Typography
                align="left"
                style={bold && italic ? { fontStyle: "italic", fontWeight: "bold" } : bold ? { fontWeight: "bold" } : italic ? { fontStyle: "italic" } : {}}
              >
                {item.name}
              </Typography>
            </Grid>
            <Grid item xs={12} md={8} align="left">
              <DateTimeTextField
                size="small"
                fullWidth
                disabled={lock}
                value={item.antwort ? item.antwort : ""}
                onChange={(e) => DateCheck(item.key, -1, e.target.value)}
              />
            </Grid>
          </Fragment>
        );
      }
      if (item.typ === "13") {
        return (
          <Fragment>
            <Grid item xs={12} md={4}>
              <Typography
                align="left"
                style={bold && italic ? { fontStyle: "italic", fontWeight: "bold" } : bold ? { fontWeight: "bold" } : italic ? { fontStyle: "italic" } : {}}
              >
                {item.name}
              </Typography>
            </Grid>
            <Grid item xs={12} md={8} align="left">
              <Autocomplete
                onChange={(event, newValue) => {
                  WertChange(item.key, -1, newValue.value);
                }}
                options={item.inhalt.split("\n").map((item2, index2) => {
                  var tmpkey = "";
                  var tmpval = "";
                  var tmppos = item2.indexOf(";");
                  if (tmppos >= 0) {
                    tmpkey = item2.substr(0, tmppos);
                    tmpval = item2.substr(tmppos + 1);
                  } else {
                    tmpkey = item2;
                    tmpval = item2;
                  }
                  return { label: tmpval, value: tmpkey };
                })}
                fullWidth
                renderInput={(params) => <TextField {...params} label="" placeholder="Suchen" />}
              />
            </Grid>
          </Fragment>
        );
      }
      if (item.typ === "14") {
        return (
          <Fragment>
            <Grid item xs={12} md={4}>
              <Typography
                align="left"
                style={bold && italic ? { fontStyle: "italic", fontWeight: "bold" } : bold ? { fontWeight: "bold" } : italic ? { fontStyle: "italic" } : {}}
              >
                {item.name}
              </Typography>
            </Grid>
            <Grid item xs={12} md={8} align="left">
              {lock ? (
                <Button variant="outlined" onClick={() => DateiLaden(item.antwort, "DMS")} disabled={!item.antwort || item.antwort.length <= 5}>
                  {item.antwort && item.antwort.length > 5 ? "Datei anzeigen" : "Keine Datei"}
                </Button>
              ) : item.antwort && item.antwort.length > 5 ? (
                <Fragment>
                  <Button variant="outlined" onClick={() => DateiLaden(item.antwort, "DMS")}>
                    {"Datei anzeigen"}
                  </Button>
                  <IconButton onClick={() => WertChange(item.key, -1, "")}>
                    <DeleteIcon />
                  </IconButton>
                </Fragment>
              ) : (
                <TextField
                  key={filekey}
                  size="small"
                  type="file"
                  inputProps={{
                    accept: "image/png,image/jpg,image/jpeg,application/pdf",
                  }}
                  onChange={(e) => readFile(e, item.key, -1)}
                />
              )}
            </Grid>
          </Fragment>
        );
      }
    }
    if (item.art === "I") {
      if (item.format && (item.format === "03" || item.format === "04")) italic = true;
      if (item.format && (item.format === "02" || item.format === "04")) bold = true;
      if (item.typ === "01") {
        return (
          <Grid item xs={12} alignItems="flex-start">
            <Typography
              style={bold && italic ? { fontStyle: "italic", fontWeight: "bold" } : bold ? { fontWeight: "bold" } : italic ? { fontStyle: "italic" } : {}}
              align="left"
            >
              {Validate(item.inhalt)}
            </Typography>
          </Grid>
        );
      }
      if (item.typ === "02") {
        return (
          <Grid item xs={12} style={{ backgroundColor: theme.palette.background.dim2 }}>
            <Typography variant="h6" align="left" style={italic ? { fontStyle: "italic", fontWeight: 700 } : { fontWeight: 700 }}>
              {Validate(item.inhalt)}
            </Typography>
          </Grid>
        );
      }
      if (item.typ === "03") {
        return (
          <Grid item xs={12}>
            <Typography style={italic ? { fontStyle: "italic", fontWeight: 700 } : { fontWeight: 700 }} align="left">
              {Validate(item.inhalt)}
            </Typography>
          </Grid>
        );
      }
      if (item.typ === "04") {
        return (
          <Grid item xs={12}>
            <Typography style={italic ? { fontStyle: "italic", fontSize: 12 } : { fontSize: 12 }} align="left">
              {Validate(item.inhalt)}
            </Typography>
          </Grid>
        );
      }
      if (item.typ === "05") {
        return (
          <Fragment>
            <Grid item xs={12} md={4}>
              <Typography
                align="left"
                style={bold && italic ? { fontStyle: "italic", fontWeight: "bold" } : bold ? { fontWeight: "bold" } : italic ? { fontStyle: "italic" } : {}}
              >
                {item.name}
              </Typography>
            </Grid>
            <Grid item xs={12} md={8} align="left">
              <TextField size="small" fullWidth value={Validate(item.inhalt)} disabled />
            </Grid>
          </Fragment>
        );
      }
      if (item.typ === "06") {
        return (
          <Fragment>
            <Grid item xs={12} md={4}>
              <Typography
                align="left"
                style={bold && italic ? { fontStyle: "italic", fontWeight: "bold" } : bold ? { fontWeight: "bold" } : italic ? { fontStyle: "italic" } : {}}
              >
                {item.name}
              </Typography>
            </Grid>
            <Grid item xs={12} md={8} align="left">
              <Button variant="outlined" onClick={() => DateiLaden(item.inhalt, "DMS")} disabled={!item.inhalt || item.inhalt.length <= 5}>
                {item.inhalt && item.inhalt.length > 5 ? "Datei anzeigen" : item.inhalt}
              </Button>
            </Grid>
          </Fragment>
        );
      }
      if (item.typ === "07") {
        return (
          <Fragment>
            <Grid item xs={12} md={4}>
              <Typography
                align="left"
                style={bold && italic ? { fontStyle: "italic", fontWeight: "bold" } : bold ? { fontWeight: "bold" } : italic ? { fontStyle: "italic" } : {}}
              >
                {item.name}
              </Typography>
            </Grid>
            <Grid item xs={12} md={8} align="left">
              <TextField size="small" fullWidth value={item.antwort} disabled />
            </Grid>
          </Fragment>
        );
      }
    }
    if (item.art === "R") {
      if (item.typ === "01") {
        return (
          <Fragment>
            <Grid item xs={12} md={4}>
              <Typography align="left">{item.name}</Typography>
            </Grid>
            <Grid item xs={12} md={8} align="left">
              {item.extra === "" && <TextField size="small" fullWidth disabled value={item.antwort ? item.antwort : ""} />}
              {item.extra !== "" && <BetragInput size="small" fullWidth disabled currency={item.extra} value={item.antwort ? item.antwort : ""} />}
            </Grid>
          </Fragment>
        );
      }
      if (item.typ === "02") {
        return (
          <Fragment>
            <Grid item xs={12} md={4}>
              <Typography align="left">{item.name}</Typography>
            </Grid>
            <Grid item xs={12} md={8} align="left">
              {item.extra === "" && <TextField size="small" fullWidth disabled value={item.antwort ? item.antwort : ""} />}
              {item.extra !== "" && <BetragInput size="small" fullWidth disabled currency={item.extra} value={item.antwort ? item.antwort : ""} />}
            </Grid>
          </Fragment>
        );
      }
      if (item.typ === "03") {
        return (
          <Fragment>
            <Grid item xs={12} md={4}>
              <Typography align="left">{item.name}</Typography>
            </Grid>
            <Grid item xs={12} md={8} align="left">
              {item.extra === "" && <TextField size="small" fullWidth disabled value={item.antwort ? item.antwort : ""} />}
              {item.extra !== "" && <BetragInput size="small" fullWidth disabled currency={item.extra} value={item.antwort ? item.antwort : ""} />}
            </Grid>
          </Fragment>
        );
      }
      if (item.typ === "04") {
        return (
          <Fragment>
            <Grid item xs={12} md={4}>
              <Typography align="left">{item.name}</Typography>
            </Grid>
            <Grid item xs={12} md={8} align="left">
              {item.extra === "" && <TextField size="small" fullWidth disabled value={item.antwort ? item.antwort : ""} />}
              {item.extra !== "" && <BetragInput size="small" fullWidth disabled currency={item.extra} value={item.antwort ? item.antwort : ""} />}
            </Grid>
          </Fragment>
        );
      }

      if (item.typ === "05") {
        return (
          <Fragment>
            <Grid item xs={12} md={4}>
              <Typography align="left">{item.name}</Typography>
            </Grid>
            <Grid item xs={12} md={8} align="left">
              {item.extra === "" && <TextField size="small" fullWidth disabled value={item.antwort ? item.antwort : ""} />}
              {item.extra !== "" && <BetragInput size="small" fullWidth disabled currency={item.extra} value={item.antwort ? item.antwort : ""} />}
            </Grid>
          </Fragment>
        );
      }
      if (item.typ === "06") {
        return (
          <Fragment>
            <Grid item xs={12} md={4}>
              <Typography align="left">{item.name}</Typography>
            </Grid>
            <Grid item xs={12} md={8} align="left">
              {item.extra === "" && (
                <TextField
                  size="small"
                  fullWidth
                  disabled={lock}
                  onChange={(e) => WertChange(item.key, ind, e.target.value)}
                  value={item.antwort ? item.antwort : ""}
                />
              )}
              {item.extra !== "" && (
                <BetragInput
                  size="small"
                  fullWidth
                  disabled={lock}
                  onChange={(e) => WertChange(item.key, -1, e)}
                  currency={item.extra}
                  value={item.antwort ? item.antwort : ""}
                />
              )}
            </Grid>
          </Fragment>
        );
      }
    }
    if (item.art === "D") {
      if (item.format && (item.format === "03" || item.format === "04")) italic = true;
      if (item.format && (item.format === "02" || item.format === "04")) bold = true;
      if (!item.typ) {
        return (
          <Fragment>
            <Grid item xs={12} md={4}>
              <Typography
                align="left"
                style={bold && italic ? { fontStyle: "italic", fontWeight: "bold" } : bold ? { fontWeight: "bold" } : italic ? { fontStyle: "italic" } : {}}
              >
                {item.name}
              </Typography>
            </Grid>
            <Grid item xs={12} md={8} align="left">
              <TextField size="small" fullWidth value={""} disabled />
            </Grid>
          </Fragment>
        );
      }
    }
  }

  function renderEingabe() {
    if (item.typ === "01") {
      return (
        <TextField
          label={!item.inhalt ? (item.label === "1" ? item.name : "") : item.antwort && item.antwort[ind] ? "" : item.inhalt}
          size="small"
          fullWidth
          value={item.antwort && item.antwort[ind] ? item.antwort[ind] : ""}
          onChange={(e) => ValidateWertChange(item.key, ind, e.target.value, item.typ, item.limit)}
          disabled={lock}
          InputLabelProps={item.inhalt ? { shrink: false } : {}}
          error={item.label === "1" && felderError?.includes(item.key + ind)}
        />
      );
    }
    if (item.typ === "02" || item.typ === "15") {
      return (
        <TextField
          label={item.label === "1" ? item.name : ""}
          size="small"
          fullWidth
          type="number"
          value={item.antwort && item.antwort[ind] ? item.antwort[ind] : ""}
          onChange={(e) => ValidateWertChange(item.key, ind, e.target.value, item.typ, item.limit)}
          onBlur={(e) => PostWertChange(item.key, ind, e.target.value, item.typ, item.von, item.bis)}
          disabled={lock}
        />
      );
    }
    if (item.typ === "03") {
      return (
        <DateTextField
          size="small"
          fullWidth
          value={item.antwort && item.antwort[ind] ? item.antwort[ind] : ""}
          onChange={(e) => WertChange(item.key, ind, e.target.value)}
          disabled={lock}
        />
      );
    }
    if (item.typ === "04") {
      return (
        <TextField
          size="small"
          fullWidth
          type="time"
          value={item.antwort && item.antwort[ind] ? item.antwort[ind] : ""}
          onChange={(e) => WertChange(item.key, ind, e.target.value)}
          disabled={lock}
        />
      );
    }
    if (item.typ === "05") {
      return (
        <FormControlLabel
          control={
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              checked={item.antwort && item.antwort[ind] === "1" ? true : false}
              onChange={(e) => WertChange(item.key, ind, e.target.checked)}
              disabled={lock}
            />
          }
          label={
            <Typography fullWidth style={felderError?.includes(item.key + ind) ? { color: setColor2("255100100", 1) } : {}}>
              {item.inhalt && item.inhalt !== "" ? item.inhalt : ""}
            </Typography>
          }
        />
      );
    }
    if (item.typ === "06") {
      return (
        <TextField
          size="small"
          fullWidth
          select
          value={item.antwort && item.antwort[ind] ? item.antwort[ind] : ""}
          onChange={(e) => WertChange(item.key, ind, e.target.value)}
          disabled={lock}
        >
          {item.inhalt.split("\n").map((item2, index2) => {
            var tmpkey = "";
            var tmpval = "";
            var tmppos = item2.indexOf(";");
            if (tmppos >= 0) {
              tmpkey = item2.substr(0, tmppos);
              tmpval = item2.substr(tmppos + 1);
            } else {
              tmpkey = item2;
              tmpval = item2;
            }
            return (
              <MenuItem key={index2} value={tmpkey} index={index2}>
                {tmpval}
              </MenuItem>
            );
          })}
        </TextField>
      );
    }
    if (item.typ === "07") {
      return (
        <TextField
          label={!item.inhalt ? (item.label === "1" ? item.name : "") : item.antwort && item.antwort[ind] ? "" : item.inhalt}
          size="small"
          fullWidth
          multiline
          value={item.antwort && item.antwort[ind] ? item.antwort[ind] : ""}
          onChange={(e) => WertChange(item.key, ind, e.target.value)}
          disabled={lock}
          InputLabelProps={item.inhalt ? { shrink: false } : {}}
        />
      );
    }
    if (item.typ === "08") {
      return (
        <Fragment>
          <Grid item xs={12} md={8}>
            <Grid container justifyContent="flex-start">
              {item.inhalt.split("\n").map((item2, index2) => {
                return (
                  <Grid item xs={12} md={4} align="left">
                    <FormControlLabel
                      control={
                        <Checkbox
                          disabled={lock}
                          icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                          checkedIcon={<CheckBoxIcon fontSize="small" />}
                          checked={item.antwort && item.antwort?.[index2.toString() + "_" + ind] === "1" ? true : false}
                          onChange={(e) => CBGroupGruppe(item.key, index2, e.target.checked ? "1" : "0", item.inhalt.split("\n").length, item.multi, ind)}
                        />
                      }
                      error={felderError.includes(item.key + (ind - 1))}
                      label={item2}
                      style={{ color: felderError.includes(item.key + (ind - 1)) ? "red" : "" }}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
        </Fragment>
      );
    }
    if (item.typ === "09") {
      if (lock) {
        return (
          <Button
            variant="outlined"
            onClick={() => DateiLaden(item.antwort[ind], "DMS")}
            disabled={!item.antwort || !item.antwort[ind] || item.antwort[ind].length <= 5}
          >
            {item.antwort && item.antwort[ind] && item.antwort[ind].length > 5 ? "Datei anzeigen" : "Keine Datei"}
          </Button>
        );
      } else {
        if (item.antwort && item.antwort[ind] && item.antwort[ind].length > 5) {
          return (
            <Fragment>
              <Button variant="outlined" onClick={() => DateiLaden(item.antwort[ind], "DMS")}>
                {"Datei anzeigen"}
              </Button>
              <IconButton onClick={() => WertChange(item.key, ind, "")}>
                <DeleteIcon />
              </IconButton>
            </Fragment>
          );
        } else {
          return (
            <TextField
              key={filekey}
              size="small"
              type="file"
              inputProps={{
                accept: "image/png,image/jpg,image/jpeg,application/pdf",
                multiple: item.multi ? true : false,
              }}
              fullWidth
              onChange={(e) => getFile(e, item.key, ind)}
            />
          );
        }
      }
    }
    if (item.typ === "10") {
      return (
        <TextField
          label={item.label === "1" ? item.name : ""}
          size="small"
          fullWidth
          value={item.antwort && item.antwort[ind] ? item.antwort[ind] : ""}
          onChange={(e) => ValidateWertChange(item.key, ind, e.target.value, item.typ, item.limit)}
          onBlur={(e) => PostWertChange(item.key, ind, e.target.value, item.typ, item.von, item.bis)}
          disabled={lock}
        />
      );
    }
    if (item.typ === "11") {
      return (
        <BetragInput
          size="small"
          disabled={lock}
          fullWidth
          currency={item.extra}
          label={item.label === "1" ? item.name : ""}
          von={item.von}
          bis={item.bis}
          negativ={item.negativ === "1" ? true : false}
          value={item.antwort && item.antwort[ind] ? item.antwort[ind] : ""}
          onChange={(e) => WertChange(item.key, ind, e)}
          //onBlur={(e)=>WertChange(item.key,ind,e)}
        />
      );
    }

    if (item.typ === "12") {
      return (
        <DateTimeTextField
          size="small"
          fullWidth
          disabled={lock}
          value={item.antwort && item.antwort[ind] ? item.antwort[ind] : ""}
          onChange={(e) => ValidateWertChange(item.key, ind, e.target.value, item.typ, item.limit)}
        />
      );
    }

    if (item.typ === "13") {
      return (
        <Autocomplete
          id={ind}
          onChange={(event, newValue) => {
            WertChange(item.key, ind, newValue.value);
          }}
          options={item.inhalt.split("\n").map((item2, index2) => {
            var tmpkey = "";
            var tmpval = "";
            var tmppos = item2.indexOf(";");
            if (tmppos >= 0) {
              tmpkey = item2.substr(0, tmppos);
              tmpval = item2.substr(tmppos + 1);
            } else {
              tmpkey = item2;
              tmpval = item2;
            }
            return { label: tmpval, value: tmpkey };
          })}
          disabled={lock}
          fullWidth
          renderInput={(params) => <TextField {...params} label="" placeholder="Suchen" />}
        />
      );
    }
    if (item.typ === "14") {
      if (lock) {
        return (
          <Button
            variant="outlined"
            onClick={() => DateiLaden(item.antwort[ind].fileKey, "DMS")}
            disabled={!item.antwort || !item.antwort[ind] || item.antwort[ind].length <= 5}
          >
            {item.antwort && item.antwort[ind] && item.antwort[ind].fileKey > 5 ? "Datei anzeigen" : "Keine Datei"}
          </Button>
        );
      } else {
        // if (item.antwort &&item.antwort[ind]) { console.log(item.antwort[ind]) }
        // console.log(item.antwort[ind])
        //      if (item.antwort && item.antwort[ind].file && item.antwort[ind].file.length > 5) {

        if (item.antwort && item.antwort[ind] && item.antwort[ind].fileKey) {
          return (
            <Fragment>
              <Button variant="outlined" onClick={() => DateiLaden(item.antwort[ind].fileKey, "DMS")}>
                {"Datei anzeigen"}
              </Button>
              <IconButton onClick={() => WertChange(item.key, ind, "")}>
                <DeleteIcon />
              </IconButton>
            </Fragment>
          );
        } else {
          return (
            <TextField
              size="small"
              type="file"
              inputProps={{
                accept: "image/png,image/jpg,image/jpeg,application/pdf",
              }}
              fullWidth
              disabled={lock}
              onChange={(e) => readFile(e, item.key, ind)}
            />
            //   <TextField
            //     key={filekey}
            //     size="small"
            //     type="file"
            //     inputProps={{
            //       accept: "image/png,image/jpg,image/jpeg,application/pdf",
            //     }}
            //     fullWidth
            //     onChange={(e) => getFile(e, item.key, ind)}
            //   />
          );
        }
      }
    }
  }

  function renderInfo() {
    if (item.typ === "01") {
      return (
        <Typography style={{ fontStyle: "italic" }} align="left">
          {Validate(item.inhalt)}
        </Typography>
      );
    }
    if (item.typ === "02") {
      return (
        <Typography variant="h6" style={{ fontWeight: 700 }} align="left">
          {Validate(item.inhalt)}
        </Typography>
      );
    }
    if (item.typ === "03") {
      return (
        <Typography style={{ fontWeight: 700 }} align="left">
          {Validate(item.inhalt)}
        </Typography>
      );
    }
    if (item.typ === "04") {
      return (
        <Typography style={{ fontSize: 3 }} align="left">
          {Validate(item.inhalt)}
        </Typography>
      );
    }
    if (item.typ === "05") {
      return <TextField size="small" fullWidth value={Validate(item.inhalt)} disabled />;
    }
  }

  function renderRechenfeld() {
    if (item.typ === "01") {
      if (item.extra === "") {
        return <TextField size="small" fullWidth disabled value={item.antwort && item.antwort[ind] ? item.antwort[ind] : ""} />;
      }
      if (item.extra !== "") {
        return <BetragInput size="small" fullWidth disabled currency={item.extra} value={item.antwort && item.antwort[ind] ? item.antwort[ind] : ""} />;
      }
    }
    if (item.typ === "02") {
      if (item.extra === "") {
        return <TextField size="small" fullWidth disabled value={item.antwort && item.antwort[ind] ? item.antwort[ind] : ""} />;
      }
      if (item.extra !== "") {
        return <BetragInput size="small" fullWidth disabled currency={item.extra} value={item.antwort && item.antwort[ind] ? item.antwort[ind] : ""} />;
      }
    }
    if (item.typ === "03") {
      return <ZeitraumInput size="small" fullWidth disabled currency={item.extra} value={item.antwort && item.antwort[ind] ? item.antwort[ind] : ""} />;
    }

    if (item.typ === "04") {
      if (item.extra === "") {
        return <TextField size="small" fullWidth disabled value={item.antwort && item.antwort[ind] ? item.antwort[ind] : ""} />;
      }
      if (item.extra !== "") {
        return <BetragInput size="small" fullWidth disabled currency={item.extra} value={item.antwort && item.antwort[ind] ? item.antwort[ind] : ""} />;
      }
    }
    if (item.typ === "05") {
      if (item.extra === "") {
        return (
          <TextField
            size="small"
            fullWidth
            disabled={true}
            // onChange={(e) => WertChange(item.key, ind, e.target.value)}
            value={item.antwort && item.antwort[ind] ? item.antwort[ind] : ""}
          />
        );
      }
      if (item.extra !== "") {
        return (
          <BetragInput
            size="small"
            fullWidth
            disabled={true}
            currency={item.extra}
            onChange={(e) => WertChange(item.key, ind, e)}
            value={item.antwort && item.antwort[ind] ? item.antwort[ind] : ""}
          />
        );
      }
    }
    if (item.typ === "06") {
      if (item.extra === "") {
        return (
          <TextField
            size="small"
            fullWidth
            disabled={lock}
            onChange={(e) => WertChange(item.key, ind, e.target.value)}
            value={item.antwort && item.antwort[ind] ? item.antwort[ind] : ""}
          />
        );
      }
      if (item.extra !== "") {
        return (
          <BetragInput
            size="small"
            fullWidth
            disabled={lock}
            currency={item.extra}
            onChange={(e) => WertChange(item.key, ind, e)}
            value={item.antwort && item.antwort[ind] ? item.antwort[ind] : ""}
          />
        );
      }
    }
    if (item.typ === "07") {
      if (item.extra === "") {
        return <TextField size="small" fullWidth disabled value={item.antwort && item.antwort[ind] ? item.antwort[ind] : ""} />;
      }
      if (item.extra !== "") {
        return <BetragInput size="small" fullWidth disabled currency={item.extra} value={item.antwort && item.antwort[ind] ? item.antwort[ind] : ""} />;
      }
    }
  }

  return <Fragment>{ind === -1 ? renderFeld() : element.art === "E" ? renderEingabe() : element.art === "I" ? renderInfo() : renderRechenfeld()}</Fragment>;
}

//export default React.memo(FormularFeld,Test);
export default FormularFeld;
